import styled from 'styled-components';
import {ByocOnboardingContainer} from '../styles';

export const SignUpContainer = styled(ByocOnboardingContainer)`
  position: relative;

  .plan-grid {
    display: flex;
    gap: 20px;
    margin-top: 24px;
    flex-wrap: wrap;
  }

  .plan-card {
    width: 22%;
    padding: 15px 10px;
    border-radius: 10px;
    border: 1px solid #d5d8de;
    background: #ffffff;
    text-align: center;
    cursor: pointer;
  }

  .plan-card__title {
    font-weight: 700;
    font-size: 12px;
    color: #2f3d48;
    margin-bottom: 8px;
  }

  .plan-card__description {
    font-size: 10px;
    color: #2f3d48;
  }

  .plan-card--active {
    border-color: #ff2d38;
    .plan-card__title,
    .plan-card__description {
      color: #ff2d38;
    }

    svg {
      path {
        fill: #ff2d38;
      }
    }
  }
`;

// Re-export common styles with SignUp-specific names for backward compatibility
export {
  ByocOnboardingTitle as SignUpTitle,
  ByocOnboardingSubtitle as SignUpSubtitle,
  ByocOnboardingText as SignUpText,
  ByocOnboardingError as SignUpError
} from '../styles';

export const SignUpCheckboxContainer = styled.div`
  display: flex;
  align-items: end;
  margin-top: 24px;

  .text {
    font-size: 14px;
    margin-left: -20px;
    span {
      color: #ff2d38;
    }
    a {
      text-decoration: none;
      font-weight: 700;
      color: #ff2d38;
    }
  }
`;

export const SignUpSignatureContainer = styled.div`
  margin-top: 7px;
  width: 100%;
`;

export const SignUpSuccessImg = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 35px;
`;

export const PromoCodeContainer = styled.div`
  width: 100%;
`;

export const PromoCodeButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  input {
    flex: 1;
  }
`;
